import { default as actionCreatorFactory } from 'typescript-fsa';
import { RawPageData, ITSEvent, ProblemStage } from 'its-pages';

export enum TestPageType {
  Bug = 'Bug',
  Generate = 'Generate',
  Result = 'Result',
  Results = 'Results',
  PageData = 'PageData'
}

const actionCreator = actionCreatorFactory('ui');

export const submitResponse = actionCreator('SUBMIT_RESPONSE');
export const problemLoaded = actionCreator<RawPageData>('PROBLEM_LOADED');
export const moveOnToNextPage = actionCreator('MOVE_ON_TO_NEXT_PAGE');
export const introShown = actionCreator('INTRO_SHOWN');
export const networkFailure = actionCreator('NETWORK_FAILURE');
export const networkRetry = actionCreator('NETWORK_RETRY');
export const showConfetti = actionCreator<boolean>('SHOW_CONFETTI');
export const logEvent = actionCreator<ITSEvent>('LOG_EVENT');
export const setStage = actionCreator<ProblemStage>('SET_STAGE');
export const setTestPageType = actionCreator<TestPageType>('SET_TEST_PAGE_TYPE');
export const setProblemLogIds = actionCreator<string[]>('SET_PROBLEM_LOG_IDS');
export const mobileDeviceDetected = actionCreator<boolean>('MOBILE_DETECTED');
export const duplicateInstanceDetected = actionCreator('DUPLICATE_INSTANCE_DETECTED');

/** User clicked on link to the end of module survey (using this as a proxy for fully completing module) */
export const endOfModuleSurveySelected = actionCreator('SURVEY_SELECTED');

/**
 * User clicked on link in end of module screen to review their responses. Request needs to be passed out
 * of this iframe back into the client context (since that is the place that has access to that save data).
 */
export const requestReviewStudentResponses = actionCreator('REQUEST_REVIEW_RESPONSES');
